var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M12.514 18.788a9.92 9.92 0 0 0 4.877 3.238 9.952 9.952 0 0 0 4.888.188 9.863 9.863 0 0 0-.187-4.88 9.895 9.895 0 0 0-2.506-4.197 14.883 14.883 0 0 0-.747-.671c.255-.21.506-.454.747-.672a9.89 9.89 0 0 0 2.507-4.197 9.86 9.86 0 0 0 .186-4.88 9.965 9.965 0 0 0-4.888.19A9.934 9.934 0 0 0 13.188 5.4c-.24.257-.465.527-.674.808-.214-.259-.456-.504-.68-.744a9.933 9.933 0 0 0-4.213-2.498 9.964 9.964 0 0 0-4.9-.184 9.86 9.86 0 0 0 .186 4.88 9.89 9.89 0 0 0 2.507 4.196c.241.241.492.454.747.672-.255.209-.506.454-.747.672a9.895 9.895 0 0 0-2.506 4.197 9.864 9.864 0 0 0-.187 4.88 9.951 9.951 0 0 0 4.9-.183 9.921 9.921 0 0 0 4.214-2.5c.24-.256.467-.526.679-.807Z",
    fill: "#FC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M18.819 12.506a9.897 9.897 0 0 0-4.293-2.024 9.808 9.808 0 0 0-2.037-4.275 9.85 9.85 0 0 0-2.032 4.275 9.896 9.896 0 0 0-4.293 2.024 9.896 9.896 0 0 0 4.293 2.024 9.827 9.827 0 0 0 2.032 4.257 9.782 9.782 0 0 0 2.037-4.275 9.896 9.896 0 0 0 4.293-2.024",
    fill: "#FC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.523 10.483a10.46 10.46 0 0 0-4.07 0 10.55 10.55 0 0 0 0 4.048c1.344.266 2.727.266 4.07 0a10.55 10.55 0 0 0 0-4.048Z",
    fill: "#FC0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export default ForwardRef;